export default __webpack_public_path__ + "static/media/toms.bdc2a976.jpg";